import { FormBase } from 'core/components';

export default class ImportPatientEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {name: 'items'},
                {name: 'templates'},
                {
                    name: 'quantity',
                    rules: 'integer'
                }
            ],
        };
    }
}
